<template>
  <div class="home" >
    <header-wrapper></header-wrapper>
<!--    <header-wrapper v-show="fullpageIndex == 0"></header-wrapper>-->
<!--    <div class="holder" v-show="fullpageIndex !== 0" style=" height: 88px;width: 100%;"></div>-->
    <!-- page -->
    <swiper :options="fullpageSwiper" ref="fullpageSwiper" class="fullpageSwiper ">
      <swiper-slide style="">
        <div class="box" style="width: 100%; height: 100%; position: relative; top: -70px;">
          <div class="textBox">
            <p style="font-size: 40px;">致力于将创新互联网产品和服务带给全球数以百万计的用户</p>
              <h1>累计用户<span class="number" style="font-size: 2em;">{{ numToThousand }}</span></h1>
              <router-link to="/companyCulture" active-class="active" >
                <button class="btn_more">了解更多</button>
              </router-link>
          </div>
        </div>
      </swiper-slide>
      <!-- 关于我们-->
      <!-- <swiper-slide style="background-color: #fff">
        <div class="user">
          <div class="userTitleWrapper">
            <img src="../../assets/img/userTitle.png" alt="" class="userTitle" >
            <div class="userNum" >
              <span class="number">{{ numToThousand }}</span><span class="users">用户</span>
            </div>
          </div>
          <div id="map" class="map"></div>
        </div>
      </swiper-slide> -->
      <!-- 公司简介-->
      <swiper-slide style="background-color: #F6F6F6" class="companyNtrFullpage">
        <div class="companyNtr">
          <div class="companyNtrTitle contentTitle">
            <p class="name">
              <img src="../../assets/img/tit_left.png" alt="">
              公司简介
            </p>
            <p class="desc">COMPANY NTRODUCTION</p>
          </div>
          <div class="description">
            <p style="margin-bottom: 35px;"> 广州悦动游戏科技有限公司，是一家专注于开发和发布高品质休闲游戏的公司。公司的使命是通过创新和娱乐性强的游戏，为全球玩家带来愉悦和乐趣。</p>
            <p> 公司致力于在休闲游戏市场中树立品牌形象，成为玩家信赖和喜爱的游戏开发商之一。 <br>公司通过不断创新、提升游戏品质和积极的市场推广，拓展国际市场，并积极寻求与合作伙伴的合作，共同推动休闲游戏产业的发展。</p>
          </div>
          <div class="ntroduction ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="2s" swiper-animate-delay="0">
            <ul>
              <li v-for="item,index in ntrList" :key="index">
                <img :src="require(`../../assets/img/jianjie_icon_${index+1}.png`)" alt="">
                <p style="margin: 0 auto;">{{ item.name }}</p>
              </li>
            </ul>
          </div>
        </div>
      </swiper-slide>
      <!-- 成长历程-->
      <swiper-slide>
        <div class="growthProcess">
          <div class="centerContent" style="position: relative;">
            <div class="growthProcessTitle contentTitle" style="width: 100%; margin-left: 0;">
              <p class="name">
                <img src="../../assets/img/tit_left.png" alt="">
                成长历程
              </p>
              <p class="desc">GROWTH PROCESS</p>
            </div>
            <!-- <div class="growthAmi" id="growthAmi" style="width: 100%"></div> -->
            <img src="../../assets/img/huojian.png" class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1.5s" swiper-animate-delay="0" style="display: block; width: 80%; margin: 0 auto;" alt="">
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="2s" style="bottom: 11.9rem; left: 12rem">
              <h2>2017.09</h2>
              <span>公司成立</span>
            </div>
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="2.2s" style="bottom: 0.1rem; left: 22rem;">
              <h2>2017.09</h2>
              <span>第一款自研产品上线</span>
            </div>
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="2.4s" style="bottom: 22.7rem; left: 28.7rem">
              <h2>2018.12</h2>
              <span>全球用户下载超五千万</span>
            </div>
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="2.6s" style="top: 29.6rem; left: 40.7rem;">
              <h2>2019.06</h2>
              <span>累计上线50款自研产品</span>
            </div>
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="2.8s" style="top: 4.3rem; left: 49rem;">
              <h2>2020.10</h2>
              <span>海外领先的激励类<br>游戏top榜首开发商</span>
            </div>
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="3s" style="top: 24.7rem; right: 25.7rem;">
              <h2>2021.09</h2>
              <span>全球用户下载超10亿</span>
            </div>
            <div class="czlc ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="3.2s" style="top: -0.7rem; right: 18.2rem;">
              <h2>2022.03</h2>
              <span>单款产品下载量破亿</span>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 公司产品-->
      <swiper-slide style="background-color: #F1F8FF">
        <div class="companyProduct" >
          <div class="centerContent">
            <div class="companyProductTitle contentTitle">
              <p class="name">
                <img src="../../assets/img/tit_left.png" alt="">
                公司产品
              </p>
              <p class="desc">COMPANY PRODUCTS</p>
            </div>
            <p class="prodDesc">
              GlobalJoy深耕激励游戏，休闲游戏等;至今下载量超过10亿次,已经覆盖全球150个国家, <br> 拥有超过60种不同的语言版本
            </p>
            <div class="swiper animate__shakeX animate__animated mediaScale">
              <swiper ref="companyPrdSwiper" :options="companyPrdSwiper" class="companyPrdSwiper ">
                <swiper-slide v-for="(item,index) in 9" :key="index">
                  <img :src="require(`../../assets/img/${index + 1}.png`)" alt="">
                </swiper-slide>
              </swiper>
              <div class="swiper-button-prev swiper-button-prev-new"></div>
              <div class="swiper-button-next swiper-button-next-new"></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- page controls -->
      <div class="swiper-pagination fullpage-swiper-pagination"  slot="pagination"></div>
    </swiper>
<!--    <footer-wrapper></footer-wrapper>-->
  </div>
</template>

<script>
import headerWrapper from '@/components/header'
import footerWrapper from "@/components/footer";

import mapAmi from '@/assets/animation/map.json'
// import growthAmi from '@/assets/animation/growthAmi.json'
import lottie from "lottie-web";

import * as swiperAni from "@/lib/animate"

export default {
  name: 'Home',
  data () {
    let that = this
    return {
      $userNumber: 0,
      fullpageIndex: 0,
      // user
      numToThousand: '',
      // swiper
      fullpageSwiper: {
        autoplay: false,
        initialSlide: 0,
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 1000,
        // setWrapperSize: true,
        mousewheel: true,//开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        // autoHeight: true,//自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        height: window.screen.availHeight-90,
        // height: 100%,
        pagination: {
          el: '.swiper-pagination',
          // bulletClass: 'my-bullet', //自定义分页器样式
          clickable: true
        },
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        on: {
          init: function () {
            swiperAni.swiperAnimateCache(this) // 隐藏动画元素
            swiperAni.swiperAnimate(this) // 初始化完成开始动画
          },
          slideChange: function () {
            swiperAni.swiperAnimate(this) // 每个slide开始切换时也运行当前slide动画
            // swiper.slides.eq(this.activeIndex).find(".ani").removeClass("ani") // 动画只展现一次，去除ani类名
          },
          transitionEnd: function (){
            that.fullpageIndex = this.activeIndex
            // if(this.activeIndex == 3){
            //   that.$nextTick(()=>{
            //   })
            // }
            // if(this.activeIndex == 2){
            //   that.starGrowthAni()
            // }else{
            //   that.growthLottie.destroy()
            // }
          }
        },
      },
      // 产品轮播swiper
      companyPrdSwiper: {
        effect: "coverflow",
        grabCursor: true,
        slidesPerView: 4,
        initialSlide: 0,
        // spaceBetween: 2,
        centeredSlides: true,
        coverflowEffect: {
          rotate: -17,
          stretch:30,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        loop: true,
        // autoplay: true,
        autoplay: {
          delay: 1300, //3秒切换一次
          pauseOnMouseEnter: true, //悬停停止切换
        },
        observer:true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        navigation:{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },

      // lottie
      mapLottie: {},
      growthLottie: {},

      ntrList: [
        { name: '自研发行一体'},
        { name: '发行联运一体'},
        { name: '中台技术赋能'},
        { name: '专业测试调优'},
        { name: '产品价值优化'},
      ]
    }


  },
  components: { headerWrapper, footerWrapper },
  mounted(){
    // 地图动画
      // this.starMapAni()
      // this.getFullHeight()
  },
  created() {
    const userNum = this.Cookies.get('numCode')
    if(userNum){
      this.$userNumber = parseInt(userNum)
    }else {
      let time = Math.abs(parseInt(new Date().getTime()/10000-60000000))
      this.$userNumber = time;
    }
    this.perNum();
  },

  // created() {
  //
  //   this.perNum();
  // },

  methods: {
    // 页面高度
    getFullHeight(){
      return window.screen.height
    },
    // 用户数量
    perNum() {
      var $addNumber = Math.ceil(Math.random() * 3);
      this.$userNumber += $addNumber;
      // 记录用户看到的用户数量
      this.Cookies.set('numCode', parseInt(this.$userNumber))

      this.$userNumToString = String(this.$userNumber);
      this.numToThousand = this.thousands(this.$userNumToString);
      setTimeout(this.perNum, Math.random() * 3 * 1000);
    },

    //
    // perNum() {
    //     var $addNumber = Math.ceil(Math.random() * 3);
    //
    //     this.$userNumber += $addNumber;
    //     // 记录用户看到的用户数量
    //     this.Cookies.set('numCode', parseInt(this.$userNumber))
    //
    //     this.$userNumToString = String(this.$userNumber);
    //     this.numToThousand = this.thousands(this.$userNumToString);
    //     setTimeout(this.perNum, 1000);
    // },

    // 数据千分位加逗号
    thousands(num) {
      var str = num.toString();
      var reg =
          str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },

    // 地图动画
    // starMapAni(){
    //   this.mapLottie = lottie.loadAnimation({
    //     container: document.getElementById('map'),
    //     renderer: 'svg',
    //     loop: true,
    //     animationData: mapAmi,
    //   })
    // },

    // 成长历程动画
    // starGrowthAni(){
    //   this.growthLottie = lottie.loadAnimation({
    //     container: document.getElementById('growthAmi'),
    //     renderer: 'svg',
    //     loop: false,
    //     animationData: growthAmi
    //   })
    // }

  }
}
</script>

<style lang="scss" scoped>
.box{
  background-image: url('../../assets/img/hme_top.png');
  .textBox{
    text-align: left;
    position: relative;
    top: 25%;
    left: 10%;
    color: #fff;
    h1{
      margin: 40px 0;
    }
    .btn_more{
      width: 206px;
      height: 57px;
      font-size: 18px;
      padding-right: 20px;
      color: #fff;
      border: none;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0);
      background-image: url("../../assets/img/btn_more.png");
      background-size: cover;
    }
  }
}
body,html{
  overflow: hidden!important;
}
.swiper-container {
  width: 100%;
  height: 841px;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.fullpageSwiper{
  .fullpage-swiper-pagination{
    ::v-deep{
      .swiper-pagination-bullet{
        background: #999999!important;
      }
      .swiper-pagination-bullet-active{
        background: #CCCCCC!important;
      }
      .swiper-slide{
        height:1px
      } /* 随意指定一个height值即可 */
      .swiper-slide-active {
        height:auto
      }
    }

  }
}

.home{
  .user{
    .userTitle{
      width: 186px;
      position: absolute;
      top: 60px;
      z-index: 1;
      margin-left: -93px;
      left: 50%;
    }
    .userNum{
      position: absolute;
      top: 40px;
      width: 1500px;
      z-index: 1;
      left: 50%;
      margin-left: -737px;
      line-height: 100px;
      .number{
        font-size: 60px;
        font-family: 'douyuFont-2';
        font-weight: 400;
        color: #FF9933;
      }
      .users{
        font-size: 20px;
        //font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FF9933;
      }
    }
    .map{
      margin-top: -112px;
      width: 1554px;
    }
  }
  .companyNtrFullpage{
    background: url("../../assets/img/companyNtrBg.png") no-repeat;
    background-position: center;
    background-size: cover;
  }
  .companyNtr{
    //background: url("../../assets/img/companyNtrBg.png") no-repeat;
    width: 100%;
    //background-position: center;
    //background-size: cover;
    position: absolute;
    top: 0;
    .companyNtrTitle{
      text-align: center;
      //position: absolute;
      //top: 85px;
      //left: 0;
      width: 100%;
      text-align: left;
      width: 100%;
      margin-top: 85px;
      margin-left: 10%;
      margin-bottom: 50px;
      .desc{
        font-size: 24px;
        color: #687088;
      }
    }
    .description{
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: 400;
      color: #687088;
      //margin-top: 50px;
      line-height: 37px;
      text-align: left;
      margin-left: 10%;
    }
    .ntroduction{
      margin-top:95px;
      ul{
        li{
          display: inline-block;
          margin-right: 116px;
          background:#FFFFFF;
          // border: 1px solid #CCCCCC;
          border-radius: 24px;
          width: 189px;
          height: 238px;
          text-align: center;
          img{
            margin:37px 0 3px 0;
          }
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }
  }
  .growthProcess{
    .growthAmi{
      position: absolute;
      top: -446px;
    }
    .growthProcessTitle{
        position: absolute;
        top: -50px;
        width: 350px;
        margin-left: 186px;
        text-align: left;
      //margin-top: 210px;
      .desc{
        color: #687088;
        font-size: 24px;
      }
    }
    .centerContent {
      width: 1580px;
      //height: 979px;
      position: relative;
      .title {
        width: 307px;
        position: absolute;
        left: 200px;
        top: 40px;
      }
      .czlc{
        position: absolute;
        text-align: left;
        h2{
          font-size: 40px;
          color: #F56057;
        }
        span{
          color: #333C58;
        }
      }
    }

  }
  .companyProduct{
    .centerContent{
      width: 1580px;
      //height: 979px;
      text-align: left;
      .title{
        width: 358px;
        margin-top: 150px;
      }
      .companyProductTitle{
        //margin-top: 220px;
        position: absolute;
        top: 85px;
        width: 100%;
        left: 0;
        text-align: left;
        .name{
          margin-left: 10%;
        }
        .desc{
          color: #687088;
          font-size: 24px;
          margin-left: 10%;
        }
      }
      .prodDesc{
        height: 50px;
        font-size: 18px;
        font-weight: 400;
        color: #687088;
        line-height: 37px;
        margin-top: 50px;
        margin-bottom: 100px;
        position: absolute;
        width: 100%;
        text-align: left;
        left: 10%;
        top: 190px;
      }
      .swiper{
        margin-top: 166px;
        .companyPrdSwiper{
          width: 1420px;
          position: relative;
        }
        .swiper-slide{
          background-color: transparent;
          opacity: 0.2;
        }
        .swiper-slide-active{
          opacity: 1;
        }
        .swiper-slide-prev, .swiper-slide-next{
          opacity: 0.9;
        }
        img{
          width: 246px;
          border-radius:51px;
        }
      }
      .swiper-button-prev-new{
        background-image: url("../../assets/img/zuojiantou.png")!important;
        width: 60px;
        height: 60px;
        background-size: cover;
        transition: all .5s ease;
        &:hover{
          background-image: url("../../assets/img/swiper-left-light.png")!important;
        }
      }
      .swiper-button-next-new{
        background-image: url("../../assets/img/youjiantou.png")!important;;
        width: 60px;
        height: 60px;
        background-size: cover;
        transition: all .5s ease;
        &:hover{
          background-image: url("../../assets/img/swiper-right-light.png")!important;
        }
      }
    }
  }
}
</style>
